<script>
import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'

const rooms = [];

export default {
    components: {
        ChatWindow
    },
    props: {
        threads: {
            type: Array
        },
        mode: {
            type: String,
            default: 'chat',
        }
    },
    created() {
        this.getRooms()
    },
    mounted() {
        if (this.mode === 'forum') {
            this.$refs["chat-window"].$el.querySelector('.vac-box-search').style.visibility = 'hidden'
        }
    },
    data() {
        return {
            rooms,
            messagesLoaded: false,
            loadingRooms: false,
            visible: false,
            messages: [],
            items: {},
            currentUserId: window.Laravel.user.hash,
            currentRoom: {},
            currentOptions: {},
            fetchNewMessages: false
        }
    },
    methods: {
        getRooms() {
            this.loadingRooms = true

            const params = {}

            if (this.mode === 'forum') {
                params['mode'] = 'forum'
            }

            this.$http
                .get(this.routeUri('api.messages'), {
                    params
                })
                .then(response => this.handleRoomsResponse(response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loadingRooms = false))
        },
        fetchMessages({room, options}) {
            this.currentRoom = room
            this.currentOptions = options
            this.messagesLoaded = false
            this.messages = []

            this.$http
                .get(this.routeUri('api.messages.show', {
                    thread: room.roomId
                }))
                .then(response => {
                    this.messages = response.data.messages
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.messagesLoaded = true))

        },
        sendMessages(roomId, content, file, replyMessage, usersTag) {
            let promise

            const data = {
                message: roomId.content
            };

            promise = this.$http.put(
                this.routeUri('api.messages.update', {
                    thread: roomId.roomId
                }),
                data
            );

            promise
                .then(response => {
                    this.messagesLoaded = false
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.fetchNewMessages = true))
        },
        openModal() {
            if (this.mode === 'chat') {
                this.visible = true
            }
        },
        closeModal() {
            this.visible = false
        },
        handleRoomsResponse(data) {
            const rooms = []

            for (let i = 0; i < data.rooms.length; i++) {
                rooms.push(data.rooms[i])
            }

            this.rooms = rooms

        },
        handleSelect(hash, name) {
            this.visible = false

            let promise

            const data = {
                receiver_id: hash
            };

            promise = this.$http.post(this.routeUri('api.messages.store'), data);

            promise
                .then(response => {
                    this.messages = []
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.getRooms()));

        },

        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
    },
    watch: {
        fetchNewMessages: function (value) {
            if (value == true) {
                this.messagesLoaded = false
                this.messages = []

                this.$http
                    .get(this.routeUri('api.messages.show', {
                        thread: this.currentRoom.roomId
                    }))
                    .then(response => {
                        this.messages = response.data.messages
                        this.fetchNewMessages = false
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.messagesLoaded = true))
            }
        }
    }
}
</script>

<template>
    <div>
        <chat-window
            ref="chat-window"
            :current-user-id="currentUserId"
            :rooms="rooms"
            :loading-rooms="loadingRooms"
            :rooms-loaded="true"
            :messages="messages"
            :messages-loaded="messagesLoaded"
            :show-emojis="false"
            :show-audio="false"
            :show-files="false"
            :show-new-messages-divider="false"
            @add-room="openModal"
            @fetch-messages="fetchMessages"
            @send-message="sendMessages"/>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <participants-list
                @handleClose="closeModal"
                @handleSelect="handleSelect"
            />
        </a-modal>
    </div>
</template>

